import { RawLocation } from 'vue-router'
import { i18n } from '@appbase/util/i18n-setup'
type VisibleHandler = (menu: MenuInfo) => boolean
export interface MenuInfo {
    name: string
    to?: RawLocation
    visible?: boolean | VisibleHandler
    children?: MenuInfo[]
    selected?: boolean
}

export function getMenues(isMailUser: boolean): MenuInfo[] {
    let returnMenus: MenuInfo[] = [];    
    
    if(isMailUser) {
        returnMenus.push({
            name: i18n.t('W_Mail').toString(),
            selected: false,
            visible: false,
            children: [
                {
                    name: i18n.t('레이아웃').toString(),
                    selected: false,
                    visible: true,
                    to: { name: 'layout' },
                },
                {
                    name: i18n.t('서명').toString(),
                    selected: false,
                    visible: true,
                    to: { name: 'signature' },
                },
                {
                    name: i18n.t('W_Settings_Rule').toString(),
                    selected: false,
                    visible: true,
                    to: { name: 'rule' },
                },
                {
                    name: i18n.t('W_Delete').toString(),
                    selected: false,
                    visible: true,
                    to: { name: 'delete' },
                },
                {
                    name: i18n.t('부재중_설정').toString(),
                    selected: false,
                    visible: true,
                    to: { name: 'missed' },
                },
                {
                    name: i18n.t('W_Mail_AutoForwarder').toString(),
                    selected: false,
                    visible: true,
                    to: { name: 'autoDelivery' },
                },
                {
                    name: i18n.t('W_Settings_Storage').toString(),
                    selected: false,
                    visible: true,
                    to: { name: 'storage' },
                },
            ],
        })
    }

    returnMenus.push({
        name: i18n.t('W_Approval').toString(),
        selected: false,
        visible: true,
        children: [
            {
                name: i18n.t('W_Settings').toString(),
                selected: false,
                visible: true,
                to: { name: 'setting' },
            },
            {
                name: i18n.t('대결자_설정').toString(),
                selected: false,
                visible: true,
                to: { name: 'confrontationView' },
            },
            {
                name: i18n.t('수신_관리').toString(),
                selected: false,
                visible: true,
                to: { name: 'reception' },
            },
            {
                name: i18n.t('결재_비밀번호_설정').toString(),
                selected: false,
                visible: false,
                to: { name: 'changeApprovalPassword' }
            },
        ],
    })

    returnMenus.push({
        name: i18n.t('언어').toString(),
        selected: false,
        visible: true,
        children: [
            {
                name: i18n.t('언어_설정').toString(),
                selected: false,
                visible: true,
                to: { name: 'language' },
            }
        ]
    })

    return returnMenus;
}